@if (isOpen$ | async) {
  <div
    class="fixed inset-0 bg-black/60 z-[70] flex items-end sm:items-center justify-center sm:p-4 backdrop-blur-sm animate-fade-in"
    (click)="close()"
  >
    <div
      class="bg-white rounded-t-3xl sm:rounded-3xl shadow-2xl w-full sm:max-w-lg overflow-hidden max-h-[95vh] flex flex-col"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div class="p-5 sm:p-6 border-b border-gray-100 shrink-0">
        <div class="flex items-center justify-between">
          <button
            (click)="$event.stopPropagation(); onGoBack()"
            class="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors cursor-pointer"
          >
            <lucide-icon [img]="icons.ArrowLeft" class="w-5 h-5"></lucide-icon>
            <span class="text-sm font-medium">Back</span>
          </button>

          <h2 class="text-lg sm:text-xl font-bold text-gray-900">Complete Payment</h2>

          <button
            (click)="close()"
            class="text-gray-400 hover:text-gray-600 cursor-pointer p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <lucide-icon [img]="icons.X" class="w-5 h-5"></lucide-icon>
          </button>
        </div>
      </div>

      <!-- Content -->
      <div class="p-5 sm:p-6 overflow-y-auto flex-1 body-block">
        <!-- Selected Plan Summary -->
        @if (currentProduct) {
          <div
            class="bg-gradient-to-r from-brand/5 to-brand/10 rounded-2xl p-4 mb-6 border border-brand/20"
          >
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm text-gray-600">Selected Plan</p>
                <p class="font-bold text-gray-900">{{ currentProduct.metadata.displayName }}</p>
              </div>
              <div class="text-right">
                @if (currentProduct.metadata.originalPrice) {
                  <p class="text-sm text-gray-400 line-through">
                    {{ currentProduct.metadata.originalPrice }}
                  </p>
                }
                <p class="text-2xl font-extrabold text-brand">
                  {{ currentProduct.metadata.displayPrice }}
                </p>
                <p class="text-xs text-gray-500">{{ currentProduct.metadata.priceSubtext }}</p>
              </div>
            </div>
          </div>
        }

        <!-- Loading State -->
        @if (isLoading$ | async) {
          <div class="flex flex-col items-center justify-center py-12">
            <lucide-icon
              [img]="icons.Loader2"
              class="w-10 h-10 text-brand animate-spin"
            ></lucide-icon>
            <p class="mt-4 text-gray-500">Preparing payment form...</p>
          </div>
        } @else if (error$ | async; as errorMessage) {
          <!-- Error State -->
          <div class="flex flex-col items-center justify-center py-8">
            <div class="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mb-4">
              <lucide-icon [img]="icons.AlertCircle" class="w-8 h-8 text-red-500"></lucide-icon>
            </div>
            <p class="text-gray-700 font-medium text-center mb-2">Something went wrong</p>
            <p class="text-gray-500 text-sm text-center mb-4">{{ errorMessage }}</p>
            <button
              (click)="retry()"
              class="px-6 py-2 bg-brand text-white rounded-full font-medium hover:bg-brand-dark transition cursor-pointer"
            >
              Try Again
            </button>
          </div>
        } @else if (merchantData$ | async; as merchantData) {
          <!-- Payment Method Selection -->
<!--          <div class="mb-6">-->
<!--            <p class="text-sm font-medium text-gray-700 mb-3">Payment Method</p>-->
<!--            <div class="grid grid-cols-2 gap-3">-->
<!--              &lt;!&ndash; Card Option &ndash;&gt;-->
<!--              <button-->
<!--                (click)="selectPaymentType('card')"-->
<!--                class="flex items-center justify-center gap-2 py-3 px-4 rounded-xl border-2 transition-all cursor-pointer"-->
<!--                [class.border-brand]="(paymentType$ | async) === 'card'"-->
<!--                [class.bg-brand/5]="(paymentType$ | async) === 'card'"-->
<!--              [class.border-gray-200]="(paymentType$ | async) !== 'card'"-->
<!--              [class.hover:border-gray-300]="(paymentType$ | async) !== 'card'"-->
<!--              >-->
<!--              <img src="images/visa.svg" alt="Visa" class="h-5"/>-->
<!--              <img src="images/mastercard.svg" alt="Mastercard" class="h-5"/>-->
<!--              <span class="text-sm font-medium text-gray-700">Card</span>-->
<!--              </button>-->

<!--              &lt;!&ndash; PayPal Option &ndash;&gt;-->
<!--              <button-->
<!--                (click)="selectPaymentType('paypal')"-->
<!--                class="flex items-center justify-center gap-2 py-3 px-4 rounded-xl border-2 transition-all cursor-pointer"-->
<!--                [class.border-brand]="(paymentType$ | async) === 'paypal'"-->
<!--                [class.bg-brand/5]="(paymentType$ | async) === 'paypal'"-->
<!--              [class.border-gray-200]="(paymentType$ | async) !== 'paypal'"-->
<!--              [class.hover:border-gray-300]="(paymentType$ | async) !== 'paypal'"-->
<!--              >-->
<!--              <img src="images/paypal.svg" alt="PayPal" class="h-5"/>-->
<!--              <span class="text-sm font-medium text-gray-700">PayPal</span>-->
<!--              </button>-->
<!--            </div>-->
<!--          </div>-->

          <!-- Card Brand Error -->
          @if (cardBrandError$ | async) {
            <div class="bg-red-50 border border-red-200 rounded-xl p-3 mb-4">
              <p class="text-sm text-red-600 text-center">
                Only Visa and Mastercard are accepted. Please use a different card.
              </p>
            </div>
          }

          <!-- Payment Form -->
          <div class="payment-form-container" [class.inline]="(paymentType$ | async) === 'paypal'">
            <app-solid-payment
              [class.show]="(paymentType$ | async) === 'card'"
              [merchantData]="merchantData"
              [formParams]="formParams"
              [paypalButtonParams]="paypalButtonParams"
              [paypalContainer]="paypalContainer"
              (success)="onPaymentSuccess($event)"
              (error)="onPaymentError($event)"
              (fail)="onPaymentFail($event)"
              (showCardBrandError)="onCardBrandError($event)"
              (mounted)="onMounted($event)"
            ></app-solid-payment>
          </div>

          <div [class.show]="(paymentType$ | async) === 'paypal'" class="paypal-container">
            <div class="paypal-loading" [class.show]="(showPayPalLoader$ | async) === true">
              <div class="button">
                <lucide-icon [img]="icons.Loader2" class="w-5 h-5 animate-spin"></lucide-icon>
                <img src="images/paypal.svg" alt="PayPal" class="h-5"/>
                <div>Buy Now</div>
              </div>
            </div>

            <div
              class="paypal-container-raw"
              [class.show]="(showPayPalLoader$ | async) !== true"
              #paypalContainer
            ></div>
          </div>

          <!-- Billing Summary -->
          @if (currentProduct) {
            <div class="mt-4 pt-4 border-t border-gray-100">
              <div class="flex items-center justify-between text-sm">
                <span class="text-gray-700 font-medium">
                  {{ currentProduct.metadata.displayName }}
                </span>
                <span class="text-gray-900 font-bold">
                  {{ getFormattedTotalPrice(currentProduct) }}
                </span>
              </div>
              <p class="text-xs text-gray-400 text-right mt-1">
                {{ getBillingFrequencyText(currentProduct) }}
              </p>
            </div>
          }
        }
      </div>

      <!-- Footer Legal Text -->
      <div class="px-5 pb-5 sm:px-6 sm:pb-6 shrink-0">
        <p class="text-[10px] sm:text-xs text-gray-400 text-center leading-relaxed">
          By completing your purchase, you agree to our
          <a href="/terms-of-use" target="_blank" class="underline hover:text-gray-600"
          >Terms of Use</a
          >
          and
          <a
            href="/privacy-policy"
            target="_blank"
            class="underline hover:text-gray-600"
          >Privacy Policy</a
          >. Your subscription will automatically renew unless cancelled.
        </p>
      </div>

      <!-- Safe area padding for mobile -->
      <div class="h-safe-area-inset-bottom sm:hidden"></div>
    </div>
  </div>
}
